// src/screens/sales/document/components/details/Details.tsx
import classes from './Details.module.sass'
import { DocumentInterface } from '../../../../../common/types/interfaces'
import { format } from 'date-fns'
import { entityTypeToText } from '../../../../../common/utils/functions/enumToText'

type Props = {
  el?: DocumentInterface
  fileUrl?: string
  onDownload: (el: DocumentInterface) => void
}

export const Details = ({ el, fileUrl, onDownload }: Props) => {
  if (!el) return null

  const formatDate = (date?: string) => {
    if (!date) return '—'
    return format(new Date(date), 'dd.MM.yyyy HH:mm')
  }

  const formatSize = (size?: number) => {
    if (!size) return '—'
    if (size < 1024) return `${size} Б`
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} КБ`
    return `${(size / 1024 / 1024).toFixed(2)} МБ`
  }

  const isImage = el.mimeType?.startsWith('image/')

  return (
    <div className={classes.container}>
      <div className={classes.title}>детали документа</div>
      <div className={classes.name}>{el.name}</div>
      <div className={classes.description}>{el.description || 'Нет описания'}</div>

      <div className={classes.sectionTitle}>Файл</div>

      {fileUrl && isImage && <img className={classes.preview} src={fileUrl} alt={el.name} />}

      <div className={classes.infoRow}>
        <span className={classes.infoLabel}>Тип</span>
        <span className={classes.infoValue}>{el.mimeType || '—'}</span>
      </div>

      <div className={classes.infoRow}>
        <span className={classes.infoLabel}>Размер</span>
        <span className={classes.infoValue}>{formatSize(el.size)}</span>
      </div>

      <button className={classes.downloadButton} onClick={() => onDownload(el)}>
        Скачать
      </button>

      <div className={classes.sectionTitle}>Системная информация</div>
      <div className={classes.infoRow}>
        <span className={classes.infoLabel}>ID</span>
        <span className={classes.infoValue}>{el.id || '—'}</span>
      </div>

      <div className={classes.infoRow}>
        <span className={classes.infoLabel}>Приватный</span>
        <span className={classes.infoValue}>{el.isPrivate ? '✅' : '❌'}</span>
      </div>

      {el.createdAt && (
        <div className={classes.infoRow}>
          <span className={classes.infoLabel}>Создан</span>
          <span className={classes.infoValue}>{formatDate(el.createdAt)}</span>
        </div>
      )}

      {el.updatedAt && (
        <div className={classes.infoRow}>
          <span className={classes.infoLabel}>Обновлён</span>
          <span className={classes.infoValue}>{formatDate(el.updatedAt)}</span>
        </div>
      )}

      {el.links && el.links.length > 0 && (
        <>
          <div className={classes.sectionTitle}>Привязки ({el.links.length})</div>
          <div className={classes.linksList}>
            {el.links.map((link, idx) => (
              <div key={link.id ?? idx} className={classes.linkItem}>
                <span className={classes.linkType}>{entityTypeToText(link.entityType)}</span>
                <div className={classes.linkBadges}>
                  {link.isAll ? (
                    <span className={classes.linkBadge}>все</span>
                  ) : (
                    <span className={classes.linkBadge}>id: {link.entityId ?? '—'}</span>
                  )}
                  <span className={classes.linkBadge}>сорт. {link.sortOrder}</span>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
